import { render, staticRenderFns } from "./NotificationEntry.vue?vue&type=template&id=2e138c1a"
import script from "./NotificationEntry.vue?vue&type=script&lang=js"
export * from "./NotificationEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports